<template>
  <div class="cutter">
    <svg :width="width" :height="height" :viewbox="viewbox">
      <defs>
        <marker id="arrow-end" markerWidth="10" markerHeight="10" refX="0" refY="3" orient="auto" markerUnits="strokeWidth">
          <path d="M0,0 L0,6 L9,3 z" fill="#000" />
        </marker>
        <marker id="arrow-start" markerWidth="10" markerHeight="10" refX="10" refY="3" orient="auto" markerUnits="strokeWidth">
          <path d="M10,0 L10,6 L1,3 z" fill="#000" />
        </marker>
      </defs>
      <g v-if="d && r">
        <path
          :d="path_geometry"
          stroke="black"
          stroke-width="2"
          fill="none"/>
        <line
          :x1="this.center.x - this.Dn/2 + 10"
          :y1="this.center.y + 50"
          :x2="this.center.x + this.Dn/2 - 10"
          :y2="this.center.y + 50"
          stroke="#000"
          stroke-width="1"
          marker-start="url(#arrow-start)"
          marker-end="url(#arrow-end)"/>
        <text text-anchor="middle" :x="this.center.x" :y="this.center.y + 65">D = {{d.toFixed(2)}} mm</text>
      </g>
      <g v-if="ap">
        <path
          :d="path_ap"
          stroke="blue"
          stroke-dasharray="5,5"
          stroke-width="1"
          fill="none"/>
        <line
          :x1="this.center.x - this.Deffn/2 + 10"
          :y1="this.center.y + 20"
          :x2="this.center.x + this.Deffn/2 - 10"
          :y2="this.center.y + 20"
          stroke="#000"
          stroke-width="1"
          marker-start="url(#arrow-start)"
          marker-end="url(#arrow-end)"/>
        <text text-anchor="middle" :x="this.center.x" :y="this.center.y + 35">Deff = {{d_eff.toFixed(2)}} mm</text>
      </g>
    </svg>
  </div>
</template>

<style lang="scss">
.cutter {
  display: flex;
  padding: 20px;
  width: 100%;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import CuttingParameters from '@/lib/cutting-parameters.js';

export default {
  name: 'Cutter',
  data: function () {
    return {
      size: 300,
      space: {
        bottom: 100
      }
    };
  },
  props: ['d', 'r', 'z', 'ap', 'ae'],
  computed: {
    width: function () {
      return 1.5 * this.Dn;
    },
    height: function () {
      return 1.5 * this.Rn + this.space.bottom;
    },
    viewbox: function () {
      return [0, 0, this.width, this.height].join(' ');
    },
    d_eff: function () {
      return CuttingParameters.calc.d_eff(this.d, this.r, this.ap);
    },
    Dn: function () {
      return this.size * this.d / this.d || this.size;
    },
    Deffn: function () {
      return this.size * this.d_eff / this.d || 0;
    },
    Rn: function () {
      return this.size * this.r / this.d || 0;
    },
    Aen: function () {
      return this.size * this.ae / this.d || 0;
    },
    Apn: function () {
      return this.size * this.ap / this.d || 0;
    },
    center: function () {
      return {x: this.width / 2, y: this.height - this.space.bottom};
    },
    path_ap: function () {
      let path = [];

      let c = this.center;
      let p1 = {x: -this.Dn/2 * 1.5, y: this.Apn};
      let p2 = {x:  this.Dn/2 * 1.5, y: this.Apn};

      path.push('M', c.x - p1.x, c.y - p1.y);
      path.push('L', c.x - p2.x, c.y - p2.y);

      return path.join(' ');
    },
    path_geometry: function () {
      let path = [];

      let c = this.center;
      let p1 = {x: 0, y: 0};
      let p2 = {x: this.Dn/2 - this.Rn, y: 0};
      let p3 = {x: this.Dn/2, y: this.Rn};
      let p4 = {x: this.Dn/2, y: this.Rn * 1.5};

      path.push('M', c.x - p1.x, c.y - p1.y);
      path.push('L', c.x - p2.x, c.y - p2.y);
      path.push('A', this.Rn, this.Rn, 90, 0, 1, c.x - p3.x, c.y - p3.y);
      path.push('L', c.x - p4.x, c.y - p4.y);

      path.push('M', c.x + p1.x, c.y - p1.y);
      path.push('L', c.x + p2.x, c.y - p2.y);
      path.push('A', this.Rn, this.Rn, 90, 0, 0, c.x + p3.x, c.y - p3.y);
      path.push('L', c.x + p4.x, c.y - p4.y);

      return path.join(' ');
    },
  },
  methods: {
  },
}
</script>
